import { useLang } from "../../i18n";

const WHATSAPP_NUMBER = "594694449985";

export function WhatsAppFloating() {
  const { t } = useLang();
  return (
    <a
      href={buildWhatsAppLink(t.wa.generic)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.wa.floating}
      data-testid="whatsapp-floating-link"
      style={{
        bottom: "calc(env(safe-area-inset-bottom, 0px) + 4.5rem)",
      }}
      className="fixed right-4 sm:right-6 z-[60] group flex items-center gap-3 rounded-full bg-[#25D366] py-3 pl-3 pr-5 shadow-[0_10px_40px_-10px_rgba(37,211,102,0.6)] transition-transform hover:scale-105"
    >
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white">
        <svg viewBox="0 0 24 24" className="h-6 w-6 fill-[#25D366]" aria-hidden="true">
          <path d="M20.52 3.48A11.84 11.84 0 0 0 12.06 0C5.5 0 .17 5.34.17 11.91a11.86 11.86 0 0 0 1.6 5.96L0 24l6.3-1.65a11.9 11.9 0 0 0 5.76 1.47h.01c6.55 0 11.89-5.34 11.89-11.9a11.83 11.83 0 0 0-3.44-8.44ZM12.06 21.8h-.01a9.86 9.86 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.27c0-5.46 4.45-9.9 9.91-9.9a9.84 9.84 0 0 1 7.01 2.9 9.83 9.83 0 0 1 2.9 7.01c0 5.46-4.45 9.9-9.93 9.9Zm5.43-7.41c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.39-1.47-.88-.78-1.47-1.74-1.65-2.04-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.21 5.09 4.5.71.31 1.27.49 1.70.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35Z" />
        </svg>
      </span>
      <span className="hidden sm:inline text-sm font-medium tracking-wide text-white">{t.wa.floating}</span>
    </a>
  );
}

// Helper to build WhatsApp links. Always use wa.me, never api.whatsapp.com.
export function buildWhatsAppLink(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export const WHATSAPP_NUMBER_E164 = WHATSAPP_NUMBER;
